import React, { useEffect } from 'react';
import { Select, Tag, Tooltip, Badge } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import useCategoryStore from '../store/useCategoryStore';

const { Option } = Select;

const ProductCategorySelect = ({ value, onChange, placeholder = "Select Category", allowClear = true, style, size, bordered, readOnly }) => {
    const { categories, loading, error, fetchCategories } = useCategoryStore();

    useEffect(() => {
        if (categories.length === 0 && !error) {
            fetchCategories();
        }
    }, [categories.length, error, fetchCategories]);

    if (readOnly) {
        const cat = categories.find(c => c.id == value);
        return cat ? <Tag color={cat.color || 'blue'}>{cat.label}</Tag> : <Tag color="default">Uncategorized</Tag>;
    }

    const dropdownPlaceholder = error ? error : placeholder;

    return (
        <Select
            showSearch
            loading={loading}
            value={value}
            onChange={onChange}
            placeholder={dropdownPlaceholder}
            allowClear={allowClear}
            disabled={!!error}
            style={style || { width: '100%' }}
            size={size}
            bordered={bordered}
            optionFilterProp="children"
        >
            {categories.map(c => (
                <Option key={c.id} value={c.id}>
                    <Space size="small">
                        <Badge color={c.color || '#1890ff'} />
                        {c.label}
                    </Space>
                </Option>
            ))}
        </Select>
    );
};

// Internal Space helper for Option formatting
const Space = ({ children, size }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: size === 'small' ? '8px' : '16px' }}>
        {children}
    </div>
);

export default ProductCategorySelect;
